import { ExpandButton } from 'common/components/expand-button';
import { StoreContext } from '../../../lib/store';
import { useContext } from 'react';
import style from './styles.scss';
import * as React from 'react';
import { btnPaddingStyle, btnPositionStyle } from 'common/js/configs/utils';

export function Component() {
  const store = useContext(StoreContext);

  const { expandBtn } = store.formatConfig;
  const { mraidStore, userExpandHandler } = store;

  const onClick = userExpandHandler
    ? userExpandHandler.handle.bind(userExpandHandler)
    : undefined;

  const expandControlBlockStyle: React.CSSProperties = btnPaddingStyle(
    4,
    expandBtn?.largeClickableZonePadding || 0,
    expandBtn?.position || 'right'
  );

  const expandBtnStyle: React.CSSProperties = btnPositionStyle(
    expandBtn?.position || 'right'
  );

  return (
    <>
      <div className={style.expandBtnPosition} style={expandBtnStyle}>
        <ExpandButton
          iconSize={expandBtn?.iconSize}
          iconPadding={expandBtn?.paddingSize}
          iconColor={expandBtn?.iconColor}
          isExpanded={mraidStore.isMraidExpanded}
          onClick={onClick}
          useArrowIcon={true}
          controlBlockStyle={expandControlBlockStyle}
        />
      </div>
    </>
  );
}
